import {QbElement} from "@qb-assets-js/qb-elements/qb-element"

export class QbParticipants extends QbElement {
    // static shadow = {mode: 'open', sheets: ["qb-elements"]};
    //
    // constructor() {
    //     super();
    //     this.contentRoot.append(
    //         BUTTON({part: "button", type: "button", events: [this, {click: "toggle"}], aria: {label: _("Group overview")}}),
    //         // BUTTON({part: "video", aria: {label: _("Video chat")}, events: [this, {click: 'toggleVideo'}], title: _("Start video chat")}),
    //         DIV({part: "scroll"},
    //             SLOT({part: "slot"})
    //         )
    //     );
    // }

    init() {
        if(!this.matches(":has(header)")) {
            let headline;
            switch(parseInt(this.closest("[data-index]").index)) {
                case 0:
                    headline = _("Competitors Waiting");
                    break;
                case -5:
                    headline = _("Competitors Finished");
                    break;
                case -1:
                case -2:
                case -3:
                case -4:
                    headline = _("Competitors Ending");
                    break;
                default:
                    headline = _("Competitors Playing");
                    break;
            }

            const header = HEADER(
                LABEL({class: "toggle_open"},
                    cT.CheckBox("toggle_open", '1', false, {
                        aria: {label: _("Toggle teams")},
                        events: [this, {change: "toggle_open"}]
                    }),
                    QbIcon("play")
                ),
                headline, {afterbegin: this}
            );
            if(self.isMc) {
                header.append(
                    BUTTON({class: "slot_all", events: [this, {click: "slot_toggle"}]}, _("Select All")),
                    BUTTON({class: "slot_none", events: [this, {click: "slot_toggle"}]}, _("Select None"))
                )
                this.addEventListener("dragover", this);
                this.addEventListener("drop", this);
            }
            else if(self.isPlayer) {
            }
        }
    }

    get show() {
        return self.Show || this.closest("qb-show");
    }

    send(...args) { this.show.send(...args) }

    #update_slots(evt) {
        const checked = !!document.body.querySelector('input[name="slot"]:checked');
        return document.body.querySelectorAll('input[name="section"]').forEach(n => n.checked = checked);
    }

    #join_slot(evt) {}

    handleEvent_slot_toggle(evt) {
        this.querySelectorAll('[name="slot"]').forEach(n => n.checked = evt.currentTarget.hasClass("slot_all"));
    }

    handleEvent_change(evt) {
        if(self.isMc) {
            switch(evt.currentTarget.name) {
                case 'slot':
                    return this.#update_slots(evt);
            }
        }
        else this.#join_slot(evt);
    }

    handleEvent_dragover(evt) {
        const item = evt.dataTransfer.items[0];
        if(!item) return evt.preventDefault();
        evt.stopImmediatePropagation();
        const round = document.documentElement.dataset.round;
        if(round !== "-0/00") return evt.preventDefault();
        const current_index = this.closest("[data-index]")?.dataset?.index,
            round_index = parseInt(current_index);
        if(round_index && evt.target.nodeName !== "QB-SLOT") return evt.preventDefault();
        const slot_index = evt.dataTransfer.items[0].type;
        if(evt.target.dataset.slot_index !== slot_index) return evt.preventDefault();
    }

    handleEvent_drop(evt) {
        const player_id = evt.dataTransfer.items[1].type;
        const draggedEl = document.body.querySelector(`qb-participants qb-player[itemid="${player_id}"]`);
        const slot_index = evt.currentTarget.nodeName === "QB-PARTICIPANTS" ? 0 : parseInt(evt.currentTarget.slot_index);
        this.send("assign_player_to_slot", {player_id, slot_index});
        if(draggedEl) draggedEl.slot_index = slot_index;
        evt.preventDefault();
        evt.stopImmediatePropagation();
    }


    handleEvent_toggleVideo(evt) {
        evt.currentTarget.setClass(Show.toggleVideo, "open");
    }

    handleEvent_addTeam(e) {
        console.log("addTeam");
    }


    handleEvent_toggle(e) {
        const nodes = [...this.parentElement.getElementsByTagName("qb-player")];
        if(this.toggleClass("open")) nodes.forEach(n => {
            n.setAttribute('draggable', 'true');
            n.addEventListener('dragstart', n)
        });
        else nodes.forEach(n => {
            n.removeAttribute('draggable');
            n.removeEventListener('dragstart', n)
        });
    }

    #participant(value) {
        const {itemtype, itemid, remove, seen_at, current_at, ...data} = value;
        if(remove) return document.body.querySelectorAll(`[itemid="${itemid}"]`).forEach(n => n.remove());
        let node = this.parentNode.querySelector(`[itemid="${itemid}"]`);
        if(!node || node.parentNode !== this) {
            node?.remove();
            node = cT(`QB-${itemtype}`, {beforeend: this, itemid, itemtype});
        }
        node.update(data);
        node.finalize;
        return node;
    }

    set participant(value) {
        // this.#participant = value;
    }

    set participants(value) {
        [value].flat(3).forEach(v => this.#participant(v));
    }

    addParticipant(value) {
        return this.#participant(value);
    }

    addParticipants(...value) {
        return value.flat(3).map(v => this.#participant(v));
    }
}

QbParticipants.register;

